import { Component, OnInit } from '@angular/core';
import { ActivationEnd, Router } from '@angular/router';
import { AuthService, BackendFeatureService, EdiWrapperComponent } from 'gung-standard';
import { distinctUntilChanged, filter, map } from 'rxjs';

@Component({
  selector: 'otto-olsen-edi-wrapper',
  standalone: false,
  templateUrl: './otto-olsen-edi-wrapper.component.html',
  styleUrl: './otto-olsen-edi-wrapper.component.scss'
})
export class OttoOlsenEdiWrapperComponent extends EdiWrapperComponent implements OnInit {
  constructor() {
    super();
    this.router.events
      .pipe(
        filter(event => event instanceof ActivationEnd),
        filter(event => (event as ActivationEnd).snapshot.component === OttoOlsenEdiWrapperComponent),
        map(event => (event as ActivationEnd).snapshot.children.length),
        distinctUntilChanged()
      )
      .subscribe(children => (this.minimize = children !== 0));
    this.minimize = !this.router.url.endsWith('/edi');

    this.backendFeatureService.isActivated('gung-feature-edi.incoming-order-responses').subscribe(isActivated => {
      if (isActivated) {
        this.incomingOrderResponsesEnabled = true;
      }
    });
  }
}
